import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4c8f2114"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4c8f2114&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c8f2114')) {
      api.createRecord('4c8f2114', component.options)
    } else {
      api.reload('4c8f2114', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4c8f2114", function () {
      api.rerender('4c8f2114', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/designCategory/components/InputBar/index.vue"
export default component.exports